import { WlEventsV4ToolbarEventTypeEnum } from './toolbar-events-v4-broadcast-event-type.enum';

/**
 * event emitted by toolbar
 */
export class WlEventsV4ToolbarEvent {
  public constructor(public type: WlEventsV4ToolbarEventTypeEnum = null, public data: any = null) { }
}
